import { useStatsigClient } from '@statsig/react-bindings'
import { usePathname } from 'next/navigation'
import { useMemo } from 'react'
import { isDesktop } from 'react-device-detect'

export const useShouldIncreaseProductVisibilityExp384 = () => {
  const statsigClient = useStatsigClient()
  const pathname = usePathname()

  const validPaths = [
    '/credit-cards/best/',
    '/credit-cards/best/balance-transfer/',
    '/credit-cards/best/low-interest/',
  ]

  const isValidPath = Boolean(validPaths.includes(pathname))

  const shouldIncreaseProductVisibility = useMemo(() => {
    const shouldBeInExperiment = isValidPath && isDesktop

    return shouldBeInExperiment
      ? statsigClient
          .getExperiment('exp_384_slim_category_design_v2')
          .get('isSlimDesign', false)
      : false
  }, [statsigClient, isValidPath, isDesktop])

  return shouldIncreaseProductVisibility
}
